/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./VIPRDecoratable',
	'./VIPRItemClass'
], function(VIPRDecoratable, VIPRItemClass) {

	// implements IItemClassSet
	class VIPRItemClassSet extends VIPRDecoratable {
		constructor(dataItems, context) {
			super(...arguments);

			this.dataItems = dataItems;
			this.context = context;

			this.itemClasses = [];
		}

		destroy() {
			this.itemClasses.forEach((itemClass, index) => {
				itemClass.destroy();
				delete this.itemClasses[index];
			});
			this.itemClasses = null;
			this.context = null;
		}

		getItemClassCount() {
			return this.dataItems.length;
		}

		getItemClass(index) {
			if (index < this.getItemClassCount() && this.itemClasses[index] === undefined) {
				this.itemClasses[index] = new VIPRItemClass(this.dataItems[index], this.context);
			}
			return this.itemClasses[index];
		}
	}

	return VIPRItemClassSet;
});